import React from 'react';
import { Phone, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-[600px] md:h-[700px] flex items-center">
      {/* Background image with overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.pexels.com/photos/31771166/pexels-photo-31771166.jpeg')`,
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Professional Roofing Services in <span className="text-red-500">Washington</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200">
            Expert roof replacement, new construction, and repair services. Quality workmanship you can trust.
          </p>

          {/* Features */}
          <div className="flex flex-wrap gap-4 mb-8">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
              <CheckCircle className="text-red-500" size={20} />
              <span className="font-medium">Free Estimates</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
              <CheckCircle className="text-red-500" size={20} />
              <span className="font-medium">24/7 Emergency</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
              <CheckCircle className="text-red-500" size={20} />
              <span className="font-medium">Licensed & Insured</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg font-semibold shadow-xl"
            >
              Get Free Estimate
            </Button>
            <Button 
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-black px-8 py-6 text-lg font-semibold"
              onClick={() => window.location.href = `tel:${companyInfo.phone.replace(/\D/g, '')}`}
            >
              <Phone className="mr-2" size={20} />
              {companyInfo.phone}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
